/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { EventBusModule } from '@common/event-bus-module';
import toast from 'react-hot-toast';

import {
  FIAT_TX_ERROR,
  FIAT_TX_MODAL_DISMISSED,
  FIAT_TX_SUCCESS,
  FIAT_RAZORPAY_TX_ERROR,
} from '@pages/BuyInsurancePage/services/plugins';

const MODULE_NAME = 'profile.machines.states.waitingForCallback';

const eventModule = () => {
  return vappContainer.get<EventBusModule>(EventBusModule.displayName);
};

export const waitingForCallback = async (context: any, event: any) => {
  const currentState = 'WAITING_FOR_FIAT_CALLBACK';
  const method = 'waitingForCallback';

  return new Promise(async (resolve, reject) => {
    const eventBus = eventModule()?.getEventBus();
    const handleTxModalDismiss = async () => {
      toast.error('Transaction Cancelled', { duration: 5000 });
      eventBus.off(FIAT_TX_MODAL_DISMISSED, handleTxModalDismiss);
      eventBus.off(FIAT_TX_SUCCESS, handleFiatTxSuccess);
      eventBus.off(FIAT_TX_ERROR, handleTxError);
      eventBus.off(FIAT_RAZORPAY_TX_ERROR, handleFiatRazorPayTxError);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    };

    const handleFiatTxSuccess = async (payload: any) => {
      eventBus.off(FIAT_TX_MODAL_DISMISSED, handleTxModalDismiss);
      eventBus.off(FIAT_TX_SUCCESS, handleFiatTxSuccess);
      eventBus.off(FIAT_TX_ERROR, handleTxError);
      eventBus.off(FIAT_RAZORPAY_TX_ERROR, handleFiatRazorPayTxError);
      window.location.href = '/my-profile';
    };

    const handleTxError = async (payload: any) => {
      toast.error(payload?.message || 'Transaction failed', { duration: 5000 });
      eventBus.off(FIAT_TX_MODAL_DISMISSED, handleTxModalDismiss);
      eventBus.off(FIAT_TX_SUCCESS, handleFiatTxSuccess);
      eventBus.off(FIAT_TX_ERROR, handleTxError);
      eventBus.off(FIAT_RAZORPAY_TX_ERROR, handleFiatRazorPayTxError);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    };

    const handleFiatRazorPayTxError = async (payload: any) => {
      payload?.message && toast.error(payload.message, { duration: 5000 });
      eventBus.off(FIAT_TX_MODAL_DISMISSED, handleTxModalDismiss);
      eventBus.off(FIAT_TX_SUCCESS, handleFiatTxSuccess);
      eventBus.off(FIAT_TX_ERROR, handleTxError);
      eventBus.off(FIAT_RAZORPAY_TX_ERROR, handleFiatRazorPayTxError);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    };

    try {
      eventBus.on(FIAT_TX_MODAL_DISMISSED, handleTxModalDismiss);
      eventBus.on(FIAT_TX_SUCCESS, handleFiatTxSuccess);
      eventBus.on(FIAT_TX_ERROR, handleTxError);
      eventBus.on(FIAT_RAZORPAY_TX_ERROR, handleFiatRazorPayTxError);
    } catch (err: any) {
      eventBus.off(FIAT_TX_MODAL_DISMISSED, handleTxModalDismiss);
      eventBus.off(FIAT_TX_SUCCESS, handleFiatTxSuccess);
      eventBus.off(FIAT_TX_ERROR, handleTxError);
      eventBus.off(FIAT_RAZORPAY_TX_ERROR, handleFiatRazorPayTxError);
      // toast.error(`${err?.message}`);
      return reject({
        key: 'WAITING_FOR_FIAT_CALLBACK',
        value: err?.message,
      });
    }
  });
};
